<script>
    import {elementInstance} from './workspacesStore.js';
    import ElementEditor from '../Element/ElementEditor.svelte';

    export let contextualEdit = true;
    export let focus = undefined;

</script>

<style>

</style>

{#if $elementInstance}
    <ElementEditor {contextualEdit} {focus} />
{/if}
